import DiamondFilled from '../../src/legacy/DiamondFilled.tsx';
export default DiamondFilled;
